export function createSquareCroppedImage({ file, crop, size = 1200, mimeType = '', fileName = '' }) {
  return new Promise((resolve, reject) => {
    if (!file || !crop) {
      reject(new Error('Missing image data.'));
      return;
    }

    const outputMimeType = mimeType || (file.type && file.type.startsWith('image/') ? file.type : 'image/jpeg');
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      const cropSize = Math.min(crop.width, crop.height);
      const outputSize = Math.min(size, Math.round(cropSize));
      const canvas = document.createElement('canvas');
      canvas.width = outputSize;
      canvas.height = outputSize;
      const context = canvas.getContext('2d');

      if (!context) {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('Canvas is not supported in this browser.'));
        return;
      }

      context.drawImage(
        image,
        crop.x,
        crop.y,
        cropSize,
        cropSize,
        0,
        0,
        outputSize,
        outputSize
      );

      const quality = outputMimeType === 'image/jpeg' || outputMimeType === 'image/webp' ? 0.92 : undefined;
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(objectUrl);
        if (!blob) {
          reject(new Error('Image processing failed.'));
          return;
        }
        resolve(new File([blob], fileName || file.name, { type: outputMimeType }));
      }, outputMimeType, quality);
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Invalid image file.'));
    };

    image.src = objectUrl;
  });
}
